<template>
  <div>
    <b-row>
      <b-col cols="12">
        <label class="text-grey">Nombre</label>
        <b-form-input
          type="text"
          v-model="formTech.name"
          placeholder="Escriba aquí"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-top">
        <label class="text-grey">DNI</label>
        <b-form-input
          type="text"
          v-model="formTech.identityDocument"
          placeholder="Escriba aquí"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-top">
        <label class="text-grey">Teléfono</label>
        <b-form-input
          type="text"
          v-model="formTech.phone"
          placeholder="Escriba aquí"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-top">
        <label class="text-grey">Proveedor</label>
        <b-form-group>
          <b-form-select v-model="formTech.providerName" size="md">
            <option :value="formTech.providerName">
              {{ formTech.providerName }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <label class="text-grey">Estado</label>
        <b-form-group>
          <b-form-select
            v-model="formTech.state"
            :options="optionStates"
            size="md"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-top">
        <label class="text-grey">Contraseña</label>
        <b-form-input
          type="password"
          v-model="formTech.password"
          autocomplete="new-password"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <label for="">Foto de perfil</label>
        <b-img v-if="formTech.photoUrl"
          v-bind="mainProps"
          :src="formTech.photoUrl"
          fluid
          alt="Foto perfil"
        ></b-img>
        <b-row class="padding-two-bottom" v-if="formTech.photoUrl">
          <b-col cols="6">
            <b-button @click="show" class="btn-dark text-center">
              Actualizar imagen técnico
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button @click="showInput = false" class="btn-dark text-center">
              Cancelar
            </b-button>
          </b-col>
        </b-row>

        <template v-if="showInput||!formTech.photoUrl">
          <div>
            <span> Carga una nueva foto de perfil </span>
            <input
              type="file"
              multiple
              name="file"
              id="fileInput"
              @change="onChange"
              ref="file"
              accept=".jpg,.jpeg,.png"
            />
          </div>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-button class="bg-orange-btn" @click="editTech">
          <font-awesome-icon icon="save" /> Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "EditTechnician",
  props: ["techId", "showModalEdit"],
  data() {
    return {
      showInput: false,
      mainProps: {
        width: 440,
        height: 440,
      },
      profilePhoto: [],
      formTech: {
        id: 0,
        identityDocument: "",
        name: "",
        phone: "",
        providerId: 0,
        providerName: "",
        state: "ACTIVE",
        password: "",
        photoUrl: "",
      },
      optionStates: [
        { value: "ACTIVE", text: "ACTIVO" },
        { value: "INACTIVE", text: "INACTIVO" },
      ],
    };
  },
  created() {
    this.getDetailsTech();
  },
  methods: {
    show() {
      this.showInput = true;
    },
    onChange() {
      let filesArr = this.$refs.file.files;
      let file = filesArr[0];
      this.profilePhoto.push(file);
      //this.files = [...this.$refs.file.files];
    },
    async getFile(file) {
      //const file = this.files[0];
      let time = this.getTimestamp();
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (ev) => {
          let data = {
            src: ev.target.result,
            filename: time + file.name,
          };
          resolve(data);
        };
        reader.readAsDataURL(file);
      });
    },
    getTimestamp() {
      return new Date().getTime();
    },
    async uploadImage() {
      const listSrc = [];
      for (var i = 0; i < this.profilePhoto.length; i++) {
        let res = await this.getFile(this.profilePhoto[i]);
        console.log(res);
        listSrc.push({
          src: res.src,
          filename: res.filename,
        });
      }
      try {
        for (var x = 0; x < listSrc.length; x++) {
          let response = await axios.post(
            process.env.VUE_APP_BASE_ONETRACK_EXT + "/upload-photo",
            {
              user: this.username,
              image: listSrc[x].src,
              type: "profile",
              filename: listSrc[x].filename,
            }, // the data to post
            {
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          this.formTech.photoUrl = response.data.imageUrl;
          console.log(response);
        }
      } catch (error) {
        this.sendAlert("danger", error.response.data.message);
      } finally {
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
        }, 3000);
      }
    },
    sendAlert(variant, msg) {
      this.$store.commit("setShowAlert", true);
      this.$store.commit("SET_ERROR_MSG", { variant: variant, msg: msg });
    },
    async editTech() {
      try {
        this.$store.commit("SET_LOADING", true);
        if (this.profilePhoto) {
          await this.uploadImage();
        }
        

        let response = await axios.put(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/technicians/" +
            this.techId,
          this.formTech,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.$emit("update:showModalEdit", false);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async getDetailsTech() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/technicians/" +
            this.techId
        );
        console.log(response.data);
        this.formTech = response.data;
        this.$bvModal.show("modal-editar-tec");
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped>
.padding-two-top {
  padding-top: 2%;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}

.text-grey {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
</style>
